<template>
	<div>
		<div v-for="node in nodes" :key="node.text" class="node">
			<b-form-checkbox
				v-model="node.selected"
				:indeterminate="isIndeterminate(node)"
				@change="toogle(node, true)"
				:disabled="isNodeDisabled(node)"
			>
				{{ node.text }}
			</b-form-checkbox>
			<div class="childList">
				<TreeView
					@notifyParent="checkChildren(node)"
					@onChange="$emit('onChange', $event)"
					:nodes="node.children"
					:rootNodes="rootNodes || nodes"
					:disabled="disabled"
					:maxSelected="maxSelected"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TreeView",
	props: {
		nodes: Array,
		rootNodes: {
			type: Array,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		maxSelected: {
			type: Number,
			default: null
		}
	},
	methods: {
		countSelected(nodes) {
			let count = 0;
			nodes.forEach((node) => {
				if (node.children && node.children.length) {
					count += this.countSelected(node.children);
				} else if (node.selected) {
					count++;
				}
			});
			return count;
		},
		isNodeDisabled(node) {
			if (this.disabled) return true;

			if (this.maxSelected !== null) {
				if (node.children && node.children.length) return true;
				const totalSelected = this.countSelected(this.rootNodes || this.nodes);
				if (!node.selected && totalSelected >= this.maxSelected) {
					return true;
				}
			}
			return false;
		},
		hasChildren(node) {
			return !!node.children;
		},
		isIndeterminate(node) {
			if (!this.hasChildren(node)) return false;
			if (this.isAllChildrenSelected(node)) return false;
			if (this.isAllChildrenUnselected(node)) return false;
			return true;
		},
		isAllChildrenSelected(node) {
			if (!this.hasChildren(node)) return node.selected;
			for (let index = 0; index < node.children.length; index++) {
				if (!node.children[index].selected) return false;
			}
			return true;
		},
		isAllChildrenUnselected(node) {
			if (!this.hasChildren(node)) return node.selected;
			for (let index = 0; index < node.children.length; index++) {
				if (node.children[index].selected || this.isIndeterminate(node.children[index])) return false;
			}
			return true;
		},
		toogle(node, notifyParent) {
			this.$emit("onChange", node);
			if (this.hasChildren(node)) {
				node.children.forEach((child) => {
					child.selected = node.selected;
					this.toogle(child, false);
				});
			}
			if (notifyParent) {
				this.$emit("notifyParent");
				this.$emit("onClickGroup");
			}
		},
		checkChildren(node) {
			node.selected = this.isAllChildrenSelected(node);
			this.$emit("onChange", node);
			this.$emit("notifyParent");
		}
	}
};
</script>

<style scoped>
.node {
	text-align: left;
}
.childList {
	margin-left: 1rem;
}
</style>
